import {
  HEALTH_LABEL_OPTIONS,
  DIET_LABEL_OPTIONS,
  MEAL_TYPE_OPTIONS,
  DISH_TYPE_OPTIONS,
} from '@/constants/dietary-goals';
import {
  getValidAllergies,
  getValidCuisineTypes,
  getValidPreferences,
  getRecipeIntoleranceTags,
} from '@/lib/clientPreferenceOptions';

export type DietaryCategory =
  | 'healthLabels'
  | 'dietLabels'
  | 'cuisineTypes'
  | 'mealTypes'
  | 'dishTypes'
  | 'allergies'
  | 'preferences'
  | 'intoleranceTags';

/**
 * Get display name for dietary values from preference-options cache (with static fallbacks).
 */
export const getDietaryDisplayName = (value: string, category: DietaryCategory): string => {
  let options: readonly { name: string; value: string }[] = [];

  switch (category) {
    case 'healthLabels':
      options = HEALTH_LABEL_OPTIONS;
      break;
    case 'dietLabels':
      options = DIET_LABEL_OPTIONS;
      break;
    case 'cuisineTypes':
      options = getValidCuisineTypes();
      break;
    case 'mealTypes':
      options = MEAL_TYPE_OPTIONS;
      break;
    case 'dishTypes':
      options = DISH_TYPE_OPTIONS;
      break;
    case 'allergies':
      options = getValidAllergies();
      break;
    case 'preferences':
      options = getValidPreferences();
      break;
    case 'intoleranceTags':
      options = getRecipeIntoleranceTags();
      break;
    default:
      return value.replace(/-/g, ' ');
  }

  const found = options.find((opt) => opt.value === value);
  if (found) return found.name;
  const spaced = value.replace(/_/g, ' ').replace(/-/g, ' ');
  return spaced.charAt(0).toUpperCase() + spaced.slice(1).toLowerCase();
};

export const getDietaryDisplayNames = (values: string[], category: DietaryCategory): string[] => {
  return values.map((value) => getDietaryDisplayName(value, category));
};

export const formatDietaryValue = (value: string): string => {
  return value.replace(/-/g, ' ');
};
